import Vue from 'vue'

import uiDatePicker from './src/ui-date-picker.vue';
import uiDateTime from './src/ui-date-time.vue';
import uiDays from './src/ui-days.vue';
import uiHours from './src/ui-hours.vue';
import uiMinutes from './src/ui-minutes.vue';
import uiMonths from './src/ui-months.vue';
import uiYears from './src/ui-years.vue';

var components = [
  uiDatePicker,
  uiDateTime,
  uiDays,
  uiHours,
  uiMinutes,
  uiMonths,
  uiYears
]

components.forEach(function(component) {
  Vue.component(component.extendOptions.name, component);
})

export default components;



//////////////////
// WEBPACK FOOTER
// ./~/ui-date-picker/index.js
// module id = 547
// module chunks = 0